import styled from '@emotion/styled';
import { Alert } from '@lightspeed/flame/Alert';
import { Box } from '@lightspeed/flame/Core';

export const StyledAlert = styled(Alert)`
  border: 1px solid #ffedd4;
  box-shadow: none;
`;

export const StyledBoxHeading = styled(Box)`
  width: 540px;
  background-color: #ddd;
  border-bottom: 2px solid #777;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 12px;
  padding-right: 12px;

  > p:first-of-type {
    font-weight: bold;
    color: #020203;
  }
`;

export const StyledContentBox = styled(Box)`
  border: 1px solid #ddd;
  border-top: none;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 18px;
  padding-bottom: 18px;
  margin-bottom: 12px;

  > * {
    font-size: 14px;
  }
`;
